import { render, staticRenderFns } from "./FulfilmentPage.vue?vue&type=template&id=38630ec9&scoped=true&"
import script from "./FulfilmentPage.vue?vue&type=script&lang=js&"
export * from "./FulfilmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38630ec9",
  null
  
)

export default component.exports